import React from "react";

import { X } from "lucide-react";

import { errorTextOf } from "../errorTextV4";

import ButtonV4 from "./ButtonV4";

type AlertV4Props = {
  tone: "danger" | "warn" | "info";
  children?: React.ReactNode;
  // error จาก API / errorMessage: แปลงเป็นข้อความเอง ว่างแล้วไม่แสดงแถบ
  error?: unknown;
  // ปุ่มเพิ่มเติมก่อนปุ่มปิด
  actions?: React.ReactNode;
  onClose?: () => void;
  // class เสริมของแถบ (เช่น hv4-mt-8 ที่แต่ละหน้าใช้จัดระยะห่าง)
  className?: string;
};

/** แถบข้อความ (class hv4-alert ใน _hisv4-base.scss) */
const AlertV4 = (props: AlertV4Props) => {
  const errorText = props.error ? (errorTextOf(props.error) ?? "เกิดข้อผิดพลาด") : null;

  if (!errorText && !props.children) {
    return null;
  }

  return (
    <div
      role={props.tone === "info" ? "status" : "alert"}
      className={`hv4-alert hv4-alert-${props.tone}${props.className ? ` ${props.className}` : ""}`}
    >
      <span className="hv4-alert-text">
        {props.children}
        {errorText}
      </span>
      {props.actions}
      {!!props.onClose && (
        <ButtonV4
          variant="plain"
          size="icon"
          className="hv4-alert-close"
          aria-label="ปิดข้อความ"
          title="ปิด"
          onClick={props.onClose}
        >
          <X size={18} aria-hidden="true" />
        </ButtonV4>
      )}
    </div>
  );
};

export default AlertV4;
